import { MIXINS } from "@/utils/mixins"
import { getAvailableGiftOptions, redeemGift } from "../../../api/store"

const state = {
  step: "gift",
  giftForm: {
    yourName: "",
    recipientName: "",
    recipientEmail: "",
    giftMessage: "",
  },
  currentGift: null,
  giftOptions: [],
  giftType: "pg_points",
  currentProMembershipImage: null,
}
const getters = {
  step: (state) => (state.step),
  giftForm: (state) => (state.giftForm),
  giftOptions: state => state.giftOptions,
  pgPointsOptions: state => state.giftOptions[0] ? state.giftOptions[0] : [],
  proMembershipOptions: state => state.giftOptions[1] ? state.giftOptions[1] : [],
  currentGift: state => state.currentGift,
  giftType: state => state.giftType,
  currentProMembershipImage: state => state.currentProMembershipImage,
}
const mutations = {
  setStep: (state, step) => (state.step = step),
  setGiftForm: (state, giftForm) => (state.giftForm = giftForm),
  setGiftOptions: (state, options) => (state.giftOptions = options),
  setCurrentGift: (state, gift) => (state.currentGift = gift),
  setGiftType: (state, giftType) => (state.giftType = giftType),
  setCurrentProMembershipImage: (state, currentProMembershipImage) => (state.currentProMembershipImage = currentProMembershipImage),
}
const actions = {
  reset ({ commit }) {
    commit("setStep", "gift")
    commit("setGiftForm", {
      yourName: "",
      recipientName: "",
      recipientEmail: "",
      giftMessage: "",
    })
  },
  async getAvailableGiftOptions ({ commit }) {
    const data = await getAvailableGiftOptions()
    commit("setGiftOptions", data)
    commit("setCurrentGift", data[0].options[0])
    MIXINS.methods.trackAnalyticsEvent("Select gift option", {
      product_id: data[0].options[0].product.id,
    })
  },
  switchGiftType ({ commit, state }, giftType) {
    commit("setGiftType", giftType)
    MIXINS.methods.trackAnalyticsEvent("Select gift category", {
      category: giftType,
    })
    if (giftType === "pg_points") {
      commit("setCurrentGift", state.giftOptions[0].options[0])
      commit("setCurrentProMembershipImage", null)
      MIXINS.methods.trackAnalyticsEvent("Select gift option", {
        product_id: state.giftOptions[0].options[0].product.id,
      })
    } else {
      commit("setCurrentGift", state.giftOptions[1].options[0])
      commit("setCurrentProMembershipImage", state.giftOptions[1].options[0].asset_variations[0])
      MIXINS.methods.trackAnalyticsEvent("Select gift option", {
        product_id: state.giftOptions[1].options[0].product.id,
      })
      MIXINS.methods.trackAnalyticsEvent("Select gift image variation", {
        variation_id: state.giftOptions[1].options[0].asset_variations[0].id,
      })
    }
  },
  async redeemGift (context, code) {
    const data = await redeemGift(code)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/store/gift.js